import { ApiServerDef } from '~/api/types';

export const defaultServer: ApiServerDef = {
  url: String(process.env.REACT_API_DEFAULT_URL),
  description: 'Local development server',
};

export const docSearchApi: ApiServerDef = {
  url: String(process.env.REACT_DOC_SEARCH_API_URL),
  description: 'Document search API',
};

export const workflowsApi: ApiServerDef = {
  url: String(process.env.REACT_EMAIL_AGENT_URL),
  description: 'Email Agent API',
};

export const docChunkFinderApi: ApiServerDef = {
  url: String(process.env.REACT_CHUNK_FINDER_API_URL),
  description: 'Document chunk finder API',
};

export const banqoraGraphQLApi: ApiServerDef = {
  url:
    process.env.REACT_BANQORA_GRAPHQL_API_URL ||
    'https://bq-mcp-graphql.banqora.dev/',
  description: 'Banqora GraphQL API',
};

export const banqoraPortfolioAnalysisApi: ApiServerDef = {
  url:
    process.env.REACT_BANQORA_PORTFOLIO_ANALYSIS_API_URL ||
    'https://bq-pfolio-analysis.banqora.dev/',
  description: 'Banqora Portfolio Analysis API',
};

export const banqoraFileExtractionApi: ApiServerDef = {
  url:
    process.env.REACT_BQ_MCP_FILE_EXTRACTION_URL ||
    'https://bq-mcp-file-extraction.banqora.dev/',
  description: 'Banqora MCP File Extraction API',
};
